import { createSlice } from '@reduxjs/toolkit';
import { post } from '../../api';

export const mailSlice = createSlice({
    // Slice name, this should be always as page name.
    name: 'mail',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },

    // Reducers will mutate the state, put all the state mutation method over here
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        loading: (state, action) => {
            state.status = action.payload ? 'loading' : 'succeeded';
        },
        initialLoading: (state, action) => {
            state.status = action.payload ? 'initialLoading' : 'succeeded';
        },

        readMail: (state, action) => {
            state.data.records = state.data.records.map((item) => {
                if (item.id === action.payload.mailId) {
                    return { ...item, read: true };
                }
                return item;
            });
        },
    },
});

export default mailSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading, readMail } = mailSlice.actions;

// Public Selectors
export const selectMailData = (state) => state.mail.data;
export const selectMailStatus = (state) => state.mail.status;
export const selectMailError = (state) => state.mail.error;

export const initializeAsync = (params) => async (dispatch) => {
    dispatch(initialLoading(true));
    const result = await post('custom/getMails', { accountIds: params.accountIds });
    if (result.isSuccess) {
        dispatch(
            initialize({
                records: result.data.map((item) => {
                    return { ...item, relatedTo: 'PRIME mail' };
                }),
            })
        );
    } else {
        dispatch(error(result.errorMessage));
    }
};

export const readMailAsync = (params) => async (dispatch) => {
    dispatch(readMail({ mailId: params.mailId }));
    const result = await post('custom/readMail', { mailId: params.mailId });
    if (!result.isSuccess) {
        dispatch(error(result.errorMessage));
    }
};
